import { IAction, isType } from '@zaibot/fsa';
import { put, takeLatest } from '@zaibot/fsa-saga';
import { select } from 'redux-saga/effects';
import { resolvePathWithOffset } from '../../abstractselection';
import { getAnchorFromDocument } from '../../anchor/index';
import { INote } from '../../types/index';
import { notesEditor, notesResource } from '../notes/resource';
import { CLEAR, FOUND, MISSING } from './actions';
import { questionsEditor } from '../question/resource';

export function* rootSaga() {
    yield takeLatest([
        CLEAR,
        notesResource.actions.CREATE_SUCCESS,
        notesResource.actions.DELETE_SUCCESS,
        notesResource.actions.LIST_SUCCESS,
        notesResource.actions.READ_SUCCESS,
        notesResource.actions.UPDATE_SUCCESS,
        notesResource.actions.RESET,
    ], update);
}

function* update(action: IAction) {
    if (!isType(action, CLEAR)) {        
        if (isType(action, notesResource.actions.DELETE_SUCCESS)) {
            yield put(notesEditor.actions.RESET({}));
            yield put(questionsEditor.actions.RESET({}));
        }      
        yield put(CLEAR({})); 
    } 

    const notes: INote[] = yield select(notesResource.selectors.items);
    const nodes = getAnchorFromDocument();

    for (const note of notes) {
        if (resolvePathWithOffset(nodes, note.startElementXPath)) {
            yield put(FOUND({ noteId: note.id }));
        } else {
            yield put(MISSING({ noteId: note.id }));
        }
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/locator/sagas.tsx